import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={16} height={16} fill="none" {...props}>
        <Path
            fill={ds.colorValue.icon.brand}
            d="M13.54 6.686c.51.815.478 1.857-.08 2.64L10.12 14H7.97l4.066-5.692a.626.626 0 0 0 .021-.695L8.548 2h2.065l2.928 4.686Z"
            opacity={0.75}
        />
        <Path
            fill={ds.colorValue.icon.brand}
            d="M7.429 6.686c.509.815.477 1.857-.081 2.64L4.008 14h-2.15l4.066-5.692a.626.626 0 0 0 .021-.695L2.437 2H4.5l2.928 4.686Z"
            opacity={0.4}
        />
    </Svg>
);
export { SvgComponent as DoubleArrow };
